import React, { ComponentProps } from 'react';
import { Route, RouteComponentProps, withRouter } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MUnlock } from "../../components/mobile/unlock";

function RouteMobUnlock(props: RouteComponentProps&ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (<>
    <Route weId={`${props.weId || ''}_chelsn`} exact path={`${parentPath}/mobile/uk/unlock`}>
      <MUnlock weId={`${props.weId || ''}_7ry997`} />
    </Route>
  </>)
}

export default withRouter(RouteMobUnlock);